export const NAME = 'product';